"use client";

import React, { useEffect } from "react";

const Refresher = () => {
  useEffect(() => {
    const hasRefreshed = sessionStorage.getItem("hasRefreshed");

    if (!hasRefreshed || hasRefreshed !== "2") {
      console.log("First tab visit — refreshing...");
      sessionStorage.setItem("hasRefreshed", "2"); // Store as string
      window.location.reload();
    }
  }, []);

  return null;
};

export default Refresher;
